import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import axios from 'axios';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-solicitar-codigo',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    CommonModule,
    MatError,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './solicitar-codigo.html',
  styleUrl: './solicitar-codigo.scss',
})
export class SolicitarCodigo {
  constructor(private readonly router: Router) {}
  isLoading = false;

  recuperarSenhaFormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  get emailControl() {
    return this.recuperarSenhaFormGroup.get('email')!;
  }

  async enviarCodigo() {
    if (this.recuperarSenhaFormGroup.invalid) {
      this.emailControl.markAsTouched();
      return;
    }

    this.isLoading = true;
    const url = `${environment.apiUrl}/auth/recovery/code`;
    try {
      await axios.post(url, {
        email: this.emailControl.value,
      });

      sessionStorage.setItem('recovery_email', this.emailControl.value ?? '');
      this.isLoading = false;

      this.router.navigate(['/auth/confirmar-codigo'], {
        queryParams: { email: this.emailControl.value },
      });
    } catch (err: any) {
      if (err.response?.status === 400) {
        this.emailControl.setErrors({ notFound: true });
      } else {
        console.error('Erro inesperado:', err);
      }
    }

    this.isLoading = false;
  }

  voltarParaLogin() {
    this.router.navigate(['/auth/login']);
  }
}
